<template>
 <v-container fluid>
    <div class="container">
      <!-- Alamat -->
      <v-row>
        <v-col cols="12">
          <div class="points d-flex justify-space-between">
            <div class="pointDtl">
              <v-icon>
                mdi-map-marker-radius
              </v-icon>
              <div>
                <p class="text-subtitle-1 ma-0 font-weight-bold">Alamat Pengiriman</p>
                <p class=" ma-0 font-weight-bold">{{ this.alamat }}</p>
              </div>
            </div>
            <div class="my-auto">
              <v-icon @click="sheetAlamat = !sheetAlamat">mdi-chevron-right</v-icon>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <!-- tampilkan cara bayar jika non reward -->
          <div v-if="mode == 'PRICE'" class="points d-flex justify-space-between pa-5">
            <div class="pointDtl">
              <v-icon>
                mdi-wallet-bifold
              </v-icon>
              <div>
                <p class="text-subtitle-1 ma-0 font-weight-bold">Virtual Account</p>
                <p>{{ this.va }}</p>
              </div>
            </div>
            <div class="my-auto">
              <span class="font-weight-bold mt-2 mr-4">BCA</span>
              <!-- <router-link :to="`/payment`">
                <v-icon>mdi-chevron-right</v-icon>
              </router-link> -->
            </div>
          </div>
          <div v-if="mode == 'POIN'">
            <div class="points d-flex justify-space-between">
              <div class="pointDtl">
                <v-img
                  max-height="40"
                  max-width="40"
                  src="@/assets/icon-color-coin.svg"
                ></v-img>
                <div>
                  <p class="text-subtitle-1 ma-0">M - Point Kamu</p>
                  <p class="totalPoint ma-0 font-weight-bold">{{ this.pointMekappin }}</p>
                </div>
              </div>
              <div class="my-auto">
                <router-link :to="`/${$constant.REWARD}`">
                <v-icon>mdi-chevron-right</v-icon>
              </router-link>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- List Produk -->
      <v-row>
        <v-col cols="12">
          <div class="d-flex flex-row justify-space-between">
            <p class="totalPesanan ma-0 pa-0">Total Pesanan ({{ this.orderItems.length }}):</p>
            <div class="descStatus">
              {{
                this.order.statusCode == 'OS_NEW' ? 'NEW' :
                this.order.statusCode == 'OS_PACKING' ? 'PACKING' : 
                this.order.statusCode == 'OS_PAID' ? 'PAID' :
                this.order.statusCode == 'OS_CANCELED' ? 'CANCELED' : ''
              }}
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <div v-if="this.orderItems.length <= 3">
            <div v-for="item in this.productListMax3" :key="item.internalId">
              <div class="card mb-3" :class="item.updateFlag == $constant.TRX_BELUM_TERSEDIA ? 'disableBackground' : ''">
                <v-img
                  :src="`data:image/png;base64,${item.iconSmall}`"
                  max-width="100%"
                  max-height="80"
                  contain
                  lazy-src="@/assets/empty-img.png"
                ></v-img>
                <div class="ml-8">
                  <p class="title-card-produk pa-0 ma-0">{{ item.productName }}</p>
                  <p class="desc-card-produk pa-0 ma-0">{{  item.rewardNoted }}</p>
                  <div class="d-flex flex-row justify-space-between mt-3">
                    <!-- Jika non reward -->
                    <div v-if="mode == 'PRICE'">
                      <!-- KALAU ADA DISC -->
                      <div v-if="item.totalDiscount != null && item.totalDiscount != ''">
                        <span class="price mr-2">Rp. {{ humanFormat(item.priceProductAmt) }}</span>
                        <span class="text-decoration-line-through mr-2">Rp. {{ humanFormat(item.priceProduct) }}</span>
                        <span class="totalDiscount">{{ item.totalDiscount }} Discount</span>
                      </div>
                      <!-- KALAU GA ADA -->
                      <div v-else>
                        <span class="price mr-2">Rp. {{ humanFormat(item.priceProductAmt) }}</span>
                      </div>
                    </div>
                    <div v-if="mode == 'POIN'">
                      <div class="d-flex flex-row">
                        <v-img
                            max-height="20"
                            max-width="20"
                            src="@/assets/icon-color-coin.svg"
                        ></v-img>
                        <span class="ml-1" style="color: #FFA800;">{{ item.pointReward}} Poin</span>
                      </div>
                    </div>
                    <div>
                      <div v-if="item.updateFlag == $constant.TRX_QUANTITY_TERUPDATE">
                        <p class="text-right ma-0 pa-0">Total di pesan: {{ item.quantity }}</p>
                        <p class="text-right ma-0 pa-0" style="color: yellowgreen;">Total di penuhi: {{ item.quantityUpdate }}</p>
                      </div>
                      <div v-else-if="item.updateFlag == $constant.TRX_BELUM_TERSEDIA">
                        <v-chip
                          class="ma-2"
                          color="primary"
                          text-color="red"
                        >
                          {{ $constant.TRX_BELUM_TERSEDIA }}
                        </v-chip>
                      </div>
                      <div v-else>
                        <p class="text-right ma-0 pa-0">Total di pesan: {{ item.quantityUpdate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-for="item in productList" :key="item.internalId">
              <div class="card mb-3" :class="item.updateFlag == $constant.TRX_BELUM_TERSEDIA ? 'disableBackground' : ''">
                <v-img
                  :src="`data:image/png;base64,${item.iconSmall}`"
                  lazy-src="@/assets/empty-img.png"
                  max-width="80"
                  max-height="80"
                  contain
                ></v-img>
                <div class="ml-8">
                  <p class="title-card-produk pa-0 ma-0">{{ item.productName }}</p>
                  <p class="desc-card-produk pa-0 ma-0">{{  item.shoppingDate }}</p>
                  <div class="d-flex flex-row justify-space-between mt-3">
                    <!-- Jika non reward -->
                    <div v-if="mode == 'PRICE'">
                      <!-- KALAU ADA DISC -->
                      <div v-if="item.totalDiscount != null && item.totalDiscount != ''">
                        <span class="price mr-2">Rp. {{ humanFormat(item.priceProductAmt) }}</span>
                        <span class="text-decoration-line-through mr-2">Rp. {{ humanFormat(item.priceProduct) }}</span>
                        <span class="totalDiscount">{{ item.totalDiscount }} Discount</span>
                      </div>
                      <!-- KALAU GA ADA -->
                      <div v-else>
                        <span class="price mr-2">Rp. {{ humanFormat(item.priceProduct) }}</span>
                      </div>
                    </div>
                    <div v-if="mode == 'POIN'">
                      <div class="d-flex flex-row">
                        <v-img
                            max-height="20"
                            max-width="20"
                            src="@/assets/icon-color-coin.svg"
                        ></v-img>
                        <span class="ml-1" style="color: #FFA800;">{{ item.pointReward}} Poin</span>
                      </div>
                    </div>
                      <div v-if="item.updateFlag == $constant.TRX_QUANTITY_TERUPDATE">
                        <p class="text-right ma-0 pa-0">Total di pesan: {{ item.quantity }}</p>
                        <p class="text-right ma-0 pa-0" style="color: yellowgreen;">Total di penuhi: {{ item.quantityUpdate }}</p>
                      </div>
                      <div v-else-if="item.updateFlag == $constant.TRX_BELUM_TERSEDIA">
                        <v-chip
                          class="ma-2"
                          color="primary"
                          text-color="red"
                        >
                          {{ $constant.TRX_BELUM_TERSEDIA }}
                        </v-chip>
                      </div>
                      <div v-else>
                        <p class="text-right ma-0 pa-0">Total di pesan: {{ item.quantityUpdate }}</p>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="mode == 'PRICE'" cols="12">
          <p class="rincian-title ma-0 pa-0">Rincian Pembayaran</p>
          <div class="d-flex flex-row justify-space-between">
            <div>
              <p>Sub Total Untuk Produk</p>
              <p>Biaya Pengiriman</p>
              <p>Pajak</p>
              <p class="total-bayar">Total Pembayaran</p>
            </div>
            <div>
              <p>Rp. {{ humanFormat(this.totalPriceAmt) }}</p>
              <p>Rp. 0</p>
              <p>{{ this.ppn }} ( {{ this.totalPPN }} )</p>
              <p class="total-bayar">Rp. {{ humanFormat(this.totalToBePaidAmt) }}</p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" v-if="mode == 'POIN'">
          <p class="rincian-title ma-0 pa-0">Rincian Pembayaran</p>
          <div class="d-flex flex-row justify-space-between">
            <div>
              <p class="total-bayar">Total Pembayaran:</p>
            </div>
            <div>
              <div class="d-flex flex-row">
                <v-img
                    max-height="20"
                    max-width="20"
                    src="@/assets/icon-color-coin.svg"
                ></v-img>
                <span class="ml-1" style="color: #FFA800;">{{ this.pointChange}} Poin</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn class="pesan" 
          @click="$router.push({name: 'transactions', params: {tab: 'tab-OS_ALL_TRANS'}})">
            Kembali
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-bottom-sheet v-model="sheetAlamat" inset class="ma-0">
            <div class="bottomDialog">
              <div>
                <p class="text-subtitle-1 ma-0 font-weight-bold text-center">
                  <span>
                    <v-icon>
                      mdi-map-marker-radius
                    </v-icon>
                  </span>
                  Alamat Pengiriman
                </p>
                <p class="totalPoint ma-0 font-weight-bold text-center">{{ this.alamat }}</p>
              </div>
            </div>
          </v-bottom-sheet>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: ['orderId','mode'],
  data() {
    return {
      order: {},
      orderItems:[],
      pointMekappin: 0,
      va: '',
      alamat: '',
      productList: [],
      productListMax3: [],
      sheetAlamat: false,
      totalPPN: '',
      ppn: '',
      totalPriceAmt: 0,
      totalToBePaidAmt: 0,
      pointChange: 0,
    };
  },
  methods: {
    ...mapActions(["refreshToken", "getOrder","getProfile","getOrderReward","getVA",]),

    toTransaction() {
      this.$router.push({ name: "transactions" });
    },

    async loadOrder(){
      await this.getOrder({
        orderId: this.orderId,
      }).then((resp) => {
        this.order = resp.data.data;
        this.orderItems = resp.data.data.orderItems;
        this.totalPPN = this.order.totalPPN;
        this.ppn = this.order.ppn;
        this.totalPriceAmt = this.order.totalPriceAmt;
        this.totalToBePaidAmt = this.order.totalToBePaidAmt;
        this.pointChange = this.order.pointChange;

        if (this.orderItems.length > 3) {
          this.productList = this.orderItems;
        }else{
          this.productListMax3 = this.orderItems;
        }

      }); 
    },

    loadPoint(){
      this.getProfile().then((resp) => {
        this.pointMekappin = resp.data.data.poin;
        this.va = this.va + resp.data.data.oid;
        this.alamat = resp.data.data.address;
      });
    },
  },
  computed: {
    ...mapState(['profile']),
  },
  mounted() {
    this.getVA().then((resp) => {
      this.va = resp.data.data.distributorVA;
    });

    this.loadPoint();
    this.loadOrder();
  },
};
</script>

<style src="./PurchaseDetails.scss" lang="scss" />